import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=265011f0&scoped=true"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=265011f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265011f0",
  null
  
)

export default component.exports